import { isEmpty } from 'lodash';

import {
  type ProductVariationFlavor,
  ProductVariationSize,
} from './ProductVariationsAccordion.interface';

export const renderArrayBasedOnOrderSort = <T extends { order?: number }>(
  data: T[],
): T[] => {
  if (!data) return [];

  return data.sort((a, b) => {
    if (a.order && b.order) {
      return a.order - b.order;
    } else if (a.order) {
      return -1;
    } else if (b.order) {
      return 1;
    } else {
      return 0;
    }
  });
};

export const flavourWithOrderKey = <T extends { order?: number }>(
  data: T[],
): T[] => {
  return data.filter((flavor) => flavor.order);
};

export const getDefaultVariation = (
  productVariations: ProductVariationSize[],
) => {
  const defaultVariation = productVariations.find((variation) => {
    return variation.flavors.some((flavor) => {
      return flavor.images?.some((image) => image.visible);
    });
  });

  return defaultVariation;
};

export const updateFlavorImages = (flavors: ProductVariationFlavor[]) => {
  return flavors.map((flavor) => {
    const imageVisibility = flavor.order === 1;

    if (isEmpty(flavor.images)) {
      if (imageVisibility) {
        flavor.images = [{ visible: imageVisibility }];
      }
    } else {
      flavor.images = (flavor.images ?? []).map((image) => ({
        ...image,
        visible: imageVisibility,
      }));
    }

    return flavor;
  });
};
